import * as React from 'react';

export type BulkActionMenuItem = {
  key: string;
  label: string;
  onClick: () => void;
  disabled?: boolean;
};

type Props = {
  label: string;
  disabled?: boolean;
  items: BulkActionMenuItem[];
};

export const BulkActionMenu: React.FC<Props> = ({ label, disabled, items }) => {
  const [isOpen, setIsOpen] = React.useState(false);

  React.useEffect(() => {
    if (!isOpen) return;

    const onDocClick = () => setIsOpen(false);
    document.addEventListener('click', onDocClick);

    return () => document.removeEventListener('click', onDocClick);
  }, [isOpen]);

  return (
    <div className="pbMenuWrap" onClick={e => e.stopPropagation()}>
      <button type="button" className="pbMenuButton" disabled={disabled} onClick={() => setIsOpen(prev => !prev)}>
        {label}
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="m7 9 5 5 5-5" />
        </svg>
      </button>

      {isOpen ? (
        <div className="pbMenuDropdown">
          {items.map(item => (
            <button
              key={item.key}
              type="button"
              className="pbMenuItem"
              disabled={item.disabled}
              onClick={() => {
                setIsOpen(false);
                item.onClick();
              }}
            >
              {item.label}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
};

BulkActionMenu.displayName = 'BulkActionMenu';
